
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/best-pam-solutions",
      function () {
        return require("private-next-pages/compare/best-pam-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/best-pam-solutions"])
      });
    }
  